import React, { FC } from "react"
import { useSelector } from "react-redux"
import { getReimbursementPercent } from "../../../../reducers/subsidyStatus"
import { getCompanyName } from "../../../../reducers/companyInfo"
import { HR } from "../../atoms/Atoms"
import { Container, H3 } from "@carrotfertility/carotene"
import { Body } from "../../atoms/Bodies"
import L10n from "../../../../lib/carrot-l10n"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const YourCostShareInformational: FC = () => {
  const reimbursementPercentInfo = useSelector(getReimbursementPercent)
  const companyNameInfo = useSelector(getCompanyName)

  return (
    <>
      <Container paddingTopBottom="large">
        <HR color={"black-10"} />
      </Container>

      <H3>{l(`Your cost share with {{companyNameInfo}}`, { companyNameInfo })}</H3>
      <Body color="black-80">
        {l(
          `Cost sharing is when your employer pays for a percentage of your medical expenses. Your employer will cover {{reimbursementPercentInfo}}% of each approved eligible expense through Carrot.`,
          { reimbursementPercentInfo }
        )}
      </Body>
    </>
  )
}

export { YourCostShareInformational }
